module.exports = __webpack_public_path__ + "img/loading.0a3d036c.svg";